import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import PessoaFisica from './views/PessoaFisica.vue'
import Contato from './views/Contato.vue'
import PessoaJuridica from './views/PessoaJuridica.vue'
import ServidorPublico from './views/ServidorPublico.vue'
import ServidorPublicoSP from './views/ServidorPublicoSP.vue'
import ServidorPublicoRJ from './views/ServidorPublicoRJ.vue'
import ServidorPublicoMG from './views/ServidorPublicoMG.vue'
import ServidorPublicoRO from './views/ServidorPublicoRO.vue'
import ServidorPublicoFederal from './views/ServidorPublicoFederal.vue'
import ServidorPublicoExercito from './views/ServidorPublicoExercito.vue'
import ServidorPublicoAeronautica from './views/ServidorPublicoAeronautica.vue'
import ContratoPF from './views/ContratoPF.vue'
import ContratoPF2 from './views/ContratoPF2.vue'
import ContratoPFF from './views/ContratoPFF.vue'
import ContratoPFsemvalor from './views/ContratoPFsemvalor.vue'
import ContratoPJ from './views/ContratoPJ.vue'
import ContratoSP from './views/ContratoSP.vue'
import ContratoFiesp from './views/ContratoFiesp.vue'
import ContratoST from './views/ContratoST.vue'
import AreaCliente from './views/AreaCliente.vue'
import PaginaRedirecionamento from './views/PaginaRedirecionamento.vue'
import GeraLink from './views/GeraLink.vue'
import AdminParceiros from './views/AdminParceiros.vue'
import Parceiro from './views/Parceiro.vue'
import Parceria_Propm from './views/Parceria_Propm.vue'
import Parceria_Igrejas from './views/Parceria_Igrejas.vue'
//import Parceria_SindLojas from './views/Parceria_SindLojas.vue'
import Parceria_Sindirepa from './views/Parceria_Sindirepa.vue'
import Parceria_SindirepaDuqueDeCaxias from './views/Parceria_SindirepaDuqueDeCaxias.vue'
import Parceria_SindirepaQueimados from './views/Parceria_SindirepaQueimados.vue'
import Parceria_SindirepaRioDeJaneiro from './views/Parceria_SindirepaRioDeJaneiro.vue'
import Parceria_Senior from './views/Parceria_Senior.vue'
import Parceria_SinteepRO from './views/Parceria_SinteepRO.vue'
import Parceria_Sinecom from './views/Parceria_Sinecom.vue'
import Parceria_sticoncimo from './views/Parceria_sticoncimo.vue'
import Parceria_sindiloto from './views/Parceria_sindiloto.vue'
import Prefeitura_SP from './views/Parceria_Prefeitura_SP.vue'
import Parceria_fiel from './views/Parceria_fiel.vue'
import Parceria_botafogo from './views/Parceria_botafogo.vue'
import Parceria_Fiesp from './views/Parceria_Fiesp'
import Parceria_Sindtransporte from './views/Parceria_Sindtransporte.vue'
import Parceria_Sintacluns from './views/Parceria_Sintacluns.vue'
import Parceria_Sindihoteis from './views/Parceria_Sindihoteis'
import ServidorRO from './views/ServidorRO.vue'
import Inclusao from './views/Inclusao.vue'
import Credenciamento from './views/Credenciamento.vue'
import ConfirmCompany from './views/ConfirmCompany.vue'
import AdminCaarj from './views/AdminCaarj.vue'
import Auth from './auth/Auth.vue'
import ConfirmCredenc from './views/ConfirmCredenc'
import Seferj from './views/Parceria_Seferj.vue'
// import Sindaerj from './views/Parceria_Sindaerj.vue'
import Senalba from './views/Parceria_Senalba.vue'
import Sintraadete from './views/Parceria_Sintraadete.vue'
import Sienf from './views/Parceria_Sienf.vue'
import Sindimei from './views/Parceria_Sindimei.vue'
import Sechs from './views/Parceria_Sechs.vue'
import Sinpro from './views/Parceria_SinproRO.vue'
import Parceria_Fettrominas from './views/Parceria_Fettrominas.vue'
import Parceria_Fettrominas_JuizDeFora_Setcjf from './views/Parceria_Fettrominas_JuizDeFora_Setcjf.vue'
import Parceria_Fettrominas_MontesClaros_Setcemg from './views/Parceria_Fettrominas_MontesClaros_Setcemg.vue'
import Parceria_Fettrominas_MontesClaros_Sindinor from './views/Parceria_Fettrominas_MontesClaros_Sindinor.vue'
import Parceria_Fettrominas_Divinopolis_Setcemg from './views/Parceria_Fettrominas_Divinopolis_Setcemg.vue'
import Parceria_Fettrominas_Divinopolis_Setcom from './views/Parceria_Fettrominas_Divinopolis_Setcom.vue'
import Parceria_Fettrominas_Passos_Setsul from './views/Parceria_Fettrominas_Passos_Setsul.vue'
import Parceria_Fettrominas_Contagem_Setcon from './views/Parceria_Fettrominas_Contagem_Setcon.vue'
import Parceria_Fettrominas_Muriae_Setcjf from './views/Parceria_Fettrominas_Muriae_Setcjf.vue'
import Parceria_Fettrominas_Para_de_Minas from './views/Parceria_Fettrominas_Para_de_Minas.vue'
import Parceria_Fettrominas_Para_de_Minas_Setcemg from './views/Parceria_Fettrominas_Para_de_Minas_setcemg.vue'
import Parceria_Fettrominas_Paracatu_Setcemg from './views/Parceria_Fettrominas_Paracatu_Setcemg.vue'
import Parceria_Fettrominas_Base_Metropolitana_Setcemg from './views/Parceria_Fettrominas_Base_Metropolitana_Setcemg.vue'
import Parceria_Fettrominas_Barbacena_Setcemg from './views/Parceria_Fettrominas_Barbacena_Setcemg.vue'
import Parceria_Fettrominas_Sete_Lagoas_Setcemg from './views/Parceria_Fettrominas_Sete_Lagoas_Setcemg.vue'
import Parceria_Fettrominas_Patos_Minas_Setcemg from './views/Parceria_Fettrominas_Patos_Minas_Setcemg.vue'
import Parceria_Fettrominas_Teofilo_Otoni_Setcemg from './views/Parceria_Fettrominas_Teofilo_Otoni_Setcemg.vue'
import Parceria_Fettrominas_Arcos_Setcemg from './views/Parceria_Fettrominas_Arcos_Setcemg.vue'
import Parceria_Fettrominas_Arcos_Setcom from './views/Parceria_Fettrominas_Arcos_Setcom.vue'
import Parceria_Fettrominas_Itauna_Setcom from './views/Parceria_Fettrominas_Itauna_Setcom.vue'
import Parceria_Fettrominas_Varginha_Setcemg from './views/Parceria_Fettrominas_Varginha_Setcemg.vue'
import Parceria_Fettrominas_Varginha_Setsul from './views/Parceria_Fettrominas_Varginha_Setsul.vue'
import { userKey } from '@/global'
import Servidor from "@/views/Servidor.vue"
import ServidorPV from "@/views/ServidorPV.vue";
import ContratoSP2 from '@/views/ContratoSP2.vue';
import PrefeituraSP from '@/views/prefeiturasp.vue';
import SegviacontratoSP from '@/views/segviacontratosp.vue';

Vue.use(VueRouter)

const routes = [
  { name: 'home', path: '/', component: Home, },
  { name: 'pessoafisica', path: '/pessoa-fisica', alias: '/pessoafisica', component: PessoaFisica },
//  { name: 'pessoafisica',   beforeEnter: (to, from, next) => { window.location.href = 'https://wwww.primavida.com.br/'}},
  { name: 'pessoajuridica', path: '/pessoa-juridica', alias: '/pessoajuridica', component: PessoaJuridica },
  //{ name: 'pessoajuridica',  beforeEnter: (to, from, next) => { window.location.href = 'https://wwww.primavida.com.br/'}},
  { name: 'servidorpublico', path: '/servidor-publico', alias: '/servidorpublico', component: ServidorPublico },
  //{ name: 'servidorpublico',  beforeEnter: (to, from, next) => { window.location.href = 'https://wwww.primavida.com.br/'}},
  { name: 'servidorpublicosp', path: '/servidor-publicosp', alias: '/servidorpublicosp', component: ServidorPublicoSP },
  { name: 'servidorpublicorj', path: '/servidor-publicorj', alias: '/servidorpublicorj', component: ServidorPublicoRJ },
  { name: 'servidorpublicomg', path: '/servidor-publicomg', alias: '/servidorpublicomg', component: ServidorPublicoMG },
  { name: 'servidorpublicoro', path: '/servidor-publicoro', alias: '/servidorpublicoro', component: ServidorPublicoRO },
  { name: 'servidorpublicofederal', path: '/servidor-publicofederal', alias: '/servidorpublicofederal', component: ServidorPublicoFederal },
  { name: 'servidorpublicoexercito', path: '/servidor-publicoexercito', alias: '/servidorpublicoexercito', component: ServidorPublicoExercito },
  { name: 'servidorpublicoaeronautica', path: '/servidor-publicoaeronautica', alias: '/servidorpublicoaeronautica', component: ServidorPublicoAeronautica },
  { name: 'contato', path: '/contato', component: Contato },
  { name: 'contratopf', path: '/contratopf', component: ContratoPF },
  { name: 'contratopf2', path: '/contratopf2', component: ContratoPF2 },
  { name: 'contratopff', path: '/contratopff', component: ContratoPFF },
  { name: 'contratopfsemvalor', path: '/contratopfsemvalor', component: ContratoPFsemvalor },
  { name: 'contratopj', path: '/contratopj', component: ContratoPJ },
  { name: 'contratosp', path: '/contratosp', component: ContratoSP },
  { name: 'contratofiesp', path: '/contratofiesp', component: ContratoFiesp },
  { name: 'contratost', path: '/contratost', alias: '/contratost', component: ContratoST },
  { name: 'areacliente', path: '/areacliente', component: AreaCliente },
  { name: 'paginaRedirecionamento', path: '/paginaRedirecionamento', component: PaginaRedirecionamento },
  { name: 'geralink', path: '/geralink', component: GeraLink },
  { name: 'adminparceiros', path: '/adminparceiros', component: AdminParceiros },
  { name: 'parceiro', path: '/uwkPvjDf6', component: Parceiro },
  { name: 'parceiro', path: '/caarj', component: Parceiro },
  { name: 'propm', path: '/propm', component: Parceria_Propm },
  { name: 'igrejas', path: '/igrejas', component: Parceria_Igrejas },
 // { name: 'sindilojas', path: '/sindilojas', component: Parceria_SindLojas },
  { name: 'sindirepa', path: '/sindirepa', component: Parceria_Sindirepa },
  { name: 'prefeitura_spbl', path: '/prefeitura_spbl', component: Prefeitura_SP },
  { name: 'prefeitura_sp', path: '/prefeitura_sp', component: ContratoSP2 },
  { name: 'sindirepariodejaneiro', path: '/sindirepariodejaneiro', component: Parceria_SindirepaRioDeJaneiro },
  { name: 'sindirepaqueimados', path: '/sindirepaqueimados', component: Parceria_SindirepaQueimados },
  { name: 'sindirepaduquedecaxias', path: '/sindirepaduquedecaxias', component: Parceria_SindirepaDuqueDeCaxias },
  { name: 'senior', path: '/senior', component: Parceria_Senior },
  { name: 'sinecom', path: '/sinecom', component: Parceria_Sinecom },
  { name: 'sticoncimo', path: '/sticoncimo', component: Parceria_sticoncimo },
  { name: 'sinteepro', path: '/sinteepro', component: Parceria_SinteepRO },
  { name: 'sindiloto', path: '/sindiloto', component: Parceria_sindiloto },
  { name: 'botafogo', path: '/botafogo', component: Parceria_botafogo },
  { name: 'fiel', path: '/fiel', component: Parceria_fiel },
  { name: 'admincaarj', path: '/admincaarj', component: AdminCaarj, meta: { requiresAdmin: true } },
  { name: 'auth', path: '/login', component: Auth },
  { name: 'confirmcompany', path: '/confirmcompany', component: ConfirmCompany },
  { name: 'servidorro', path: '/servidorro', component: ServidorRO },
  { name: 'inclusao', path: '/inclusao', component: Inclusao },
  { name: 'credenciamento', path: '/credenciamento', component: Credenciamento },
  { name: 'fiesp', path: '/fiesp', component: Parceria_Fiesp },
  { name: 'sindtransportez', path: '/sindtransportez', component: Parceria_Sindtransporte },
  { name: 'sintacluns', path: '/sintacluns', component: Parceria_Sintacluns },
  { name: 'sindihoteis', path: '/sindihoteis', component: Parceria_Sindihoteis },
  { name: 'confirmcredenc', path: '/confirmcredenc', component: ConfirmCredenc },
  { name: 'seferj', path: '/seferj', component: Seferj },
  // { name: 'sindaerj', path: '/sindaerj', component: Sindaerj },
  { name: 'senalba', path: '/senalba', component: Senalba },
  { name: 'sintraadete', path: '/sintraadete', component: Sintraadete },
  { name: 'sienf', path: '/sienf', component: Sienf },
  { name: 'sindimei', path: '/sindimei', component: Sindimei },
  { name: 'sechs', path: '/sechs', component: Sechs },
  { name: 'sinpro', path: '/sinpro', component: Sinpro },
  { name: 'fettrominas', path: '/fettrominas', component: Parceria_Fettrominas },
  { name: 'fettrominassetcjf', path: '/fettrominassetcjf', component: Parceria_Fettrominas_JuizDeFora_Setcjf },
  { name: 'fettrominassetcemgmc', path: '/fettrominassetcemgmc', component: Parceria_Fettrominas_MontesClaros_Setcemg },
  { name: 'fettrominassindinormc', path: '/fettrominassindinormc', component: Parceria_Fettrominas_MontesClaros_Sindinor },
  { name: 'fettrominassetcemgd', path: '/fettrominassetcemgd', component: Parceria_Fettrominas_Divinopolis_Setcemg },
  { name: 'fettrominassetcomd', path: '/fettrominassetcomd', component: Parceria_Fettrominas_Divinopolis_Setcom },
  { name: 'fettrominassetsul', path: '/fettrominassetsul', component: Parceria_Fettrominas_Passos_Setsul },
  { name: 'fettrominasmuriae', path: '/fettrominasmuriae', component: Parceria_Fettrominas_Muriae_Setcjf },
  { name: 'fettrominascontagem', path: '/fettrominascontagem', component: Parceria_Fettrominas_Contagem_Setcon },
  { name: 'fettrominasparademinas', path: '/fettrominasparademinas', component: Parceria_Fettrominas_Para_de_Minas },
  { name: 'fettrominasparademinassetcemg', path: '/fettrominasparademinassetcemg', component: Parceria_Fettrominas_Para_de_Minas_Setcemg },
  { name: 'fettrominasparacatu', path: '/fettrominasparacatu', component: Parceria_Fettrominas_Paracatu_Setcemg },
  { name: 'fettrominasbasemetropolitana', path: '/fettrominasbasemetropolitana', component: Parceria_Fettrominas_Base_Metropolitana_Setcemg },
  { name: 'fettrominasbarbacena', path: '/fettrominasbarbacena', component: Parceria_Fettrominas_Barbacena_Setcemg },
  { name: 'fettrominassetelagoassetcemg', path: '/fettrominassetelagoassetcemg', component: Parceria_Fettrominas_Sete_Lagoas_Setcemg },
  { name: 'fettrominaspatosminassetcemg', path: '/fettrominaspatosminassetcemg', component: Parceria_Fettrominas_Patos_Minas_Setcemg },
  { name: 'fettrominasoteofilootonisetcemg', path: '/fettrominasoteofilootonisetcemg', component: Parceria_Fettrominas_Teofilo_Otoni_Setcemg },
  { name: 'fettrominasarcossetcemg', path: '/fettrominasarcossetcemg', component: Parceria_Fettrominas_Arcos_Setcemg },
  { name: 'fettrominasarcossetcom', path: '/fettrominasarcossetcom', component: Parceria_Fettrominas_Arcos_Setcom },
  //{ name: 'fettrominasitaunasetcom', path: '/fettrominasitaunasetcom', component: Parceria_Fettrominas_Itauna_Setcom },
  { name: 'fettrominasvarginhasetcemg', path: '/fettrominasvarginhasetcemg', component: Parceria_Fettrominas_Varginha_Setcemg },
  { name: 'fettrominasvarginhasetsul', path: '/fettrominasvarginhasetsul', component: Parceria_Fettrominas_Varginha_Setsul },
  { name: 'servidor', path: '/servidor', component: Servidor },
  { name: 'servidorpv', path: '/servidorpv', component: ServidorPV },
  { name: 'segviacontratosp', path: '/segviacontratosp', component: SegviacontratoSP },
  { name: 'prefeiturasp', path: '/prefeiturasp', component: PrefeituraSP },
  ]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Lista de rotas que serão redirecionadas para o site institucional
const rotasQueRedirecionam = [
  '/',
  '/pessoafisica',
  '/pessoajuridica',
  '/servidorpublico',
  '/servidorpublicosp',
  '/servidorpublicorj',
  '/servidorpublicomg',
  '/servidorpublicoro',
  '/servidor',
  '/servidorpv',
  '/prefeiturasp',
  '/areacliente',
  '/pessoa-fisica',
  '/pessoa-juridica',
  '/servidor-publico',
  '/servidor-publicosp',
  '/servidor-publicorj',
  '/servidor-publicomg', 
  '/servidor-publicoro',
  '/servidor-publicofederal',
  '/servidor-publicoexercito',
  '/servidor-publicoaeronautica',
  '/servidorro'

]

// Middleware global de navegação
router.beforeEach((to, from, next) => {
  const json = localStorage.getItem('userKey')

  // Redirecionamento para o site institucional
  if (rotasQueRedirecionam.includes(to.path)) {
    window.location.href = 'https://www.primavida.com.br'
    return
  }

  // Controle de acesso para páginas restritas (admin)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    try {
      const user = JSON.parse(json)
      if (user === "ADMIN") {
        next()
      } else {
        next({ path: '/login' })
      }
    } catch (e) {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

export default router
